"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        content: function (_a) {
            var background = _a.background;
            return ({
                backgroundColor: background === 'paper' ? theme.palette.background.paper : theme.palette.background.default,
            });
        },
    });
});
